// Utility: determine if boost flag is on, regardless of data type
export function isBoostOn(flag) {
  if (flag === true || flag === 1) return true;
  if (typeof flag === 'string') {
    const f = flag.trim().toLowerCase();
    return f === 'true' || f === '1' || f === 'yes' || f === 'on';
  }
  return false;
}

// Utility: determine if boost is active considering expiration
export function isBoostActive(boosted, boostExpiresAt) {
  if (!isBoostOn(boosted)) return false;
  if (!boostExpiresAt) return true; // treat as active if no expiry provided
  try {
    const expiry = new Date(boostExpiresAt);
    return Date.now() < expiry.getTime();
  } catch (e) {
    return true;
  }
}

// Shared card highlight style when boost is active
export const boostCardSx = {
  backgroundColor: 'rgba(255, 249, 196, 0.7)',
  border: '1px solid',
  borderColor: 'warning.light',
};